"use strict";
const angular = require("angular");

export class incidentAttachmentComponent {
  constructor(FileUploader, $rootScope, $cookies, $uibModal, ngToast, $http) {
    "ngInject";

    // this.FileUploader = FileUploader;
    this.$rootScope = $rootScope;
    this.$cookies = $cookies;
    this.FileUploader = FileUploader;
    this.$uibModal = $uibModal;
    this.ngToast = ngToast;
    this.$http = $http;
  }

  $onInit() {
    let FileUploader = this.FileUploader;
    this.uploader = new FileUploader({
      url: `/api/incidents/${this.incidentId}/uploadAttachment`,
      headers: {
        "X-XSRF-TOKEN": this.$cookies.get("XSRF-TOKEN")
      },
      filters: [
        {
          name: "Only images or PDF files can be attached.",
          fn: (item, options) => {
            console.log("here: ", item, options);
            return item.type.startsWith("image") || item.type.endsWith("pdf");
          }
        }
      ]
    });

    this.uploader.onWhenAddingFileFailed = (item, filter, options) => {
      console.log(item, filter, options);
      this.ngToast.create({ className: "danger", content: filter.name });
    };

    // this.uploader.filters.push()

    this.uploader.onAfterAddingFile = item => {
      console.log("item has been added:", item);

      var reader = new FileReader();
      reader.onload = event => {
        item.preview = event.target.result;
        console.log("preview:", item.preview);

        this.$rootScope.$digest();
      };
      reader.readAsDataURL(item._file);
    };

    this.uploader.onSuccessItem = (item, response) => {
      console.log("response:", response);

      this.attachments.push(response);
    };

    this.uploader.onErrorItem = item => {
      console.log("error: ", item);
    };
  }

  getImage(item) {
    console.log("getImage from data: ", item);
  }

  openAttachment(attachment) {
    this.$uibModal.open({
      animation: false,
      windowClass: "attachment-modal",
      template: `<img class="img-responsive" ng-src="/api/incidents/attachment/${attachment.id}">`
    });
  }
  s;

  deleteAttachment(attachment) {
    console.log("popup here to confirm delete of: ", attachment);
    var modalScope = this.$rootScope.$new();
    // angular.extend(modalScope, {this.incident});

    modalScope.$uibModalInstance = this.$uibModal.open({
      animation: false,
      template: require("./deleteAttachment.html"),
      scope: modalScope
    });

    modalScope.$uibModalInstance.result.then(() => {
      console.log("need to delete this: ", attachment);

      this.$http.delete(`/api/incidents/attachment/${attachment.id}`).then(
        () => {
          _.remove(this.attachments, a => a.id === attachment.id);
        },
        error => {
          this.ngToast.create({
            className: "danger",
            content: `Error: An error occured: ${error.data.name}: ${error.data.message}`
          });
          console.log(error);
        }
      );
    });
  }
}

export default angular
  .module("hccApp.incidentAttachment", [])
  .component("incidentAttachment", {
    template: require("./incidentAttachment.html"),
    bindings: {
      attachments: "=",
      incidentId: "@"
    },
    controller: incidentAttachmentComponent
  }).name;



// WEBPACK FOOTER //
// ./client/app/incident/incidentAttachment/incidentAttachment.component.js